import styled from 'styled-components';

export const Input = styled.input`
  border: none;
  border-radius: 999px;
  font-size: 16px;
  padding: 14px;
  height: 58px;
  width: 100%;
  margin: 10px 0;

  ::placeholder {
    color: #979797;
    opacity: 1;
  }
`;
